import React from "react"
import { FlexContainer, H3, Stack, Text } from "@carrotfertility/carotene"
import { CircleImage } from "../../../views/atoms/images/CircleImage"
import { FormattedMessage } from "react-intl"

const CarrotRxMedicationCard = (): JSX.Element => (
  <FlexContainer data-testid="carrot-rx-medication-card" sx={{ backgroundColor: "#F0F0F0", borderRadius: "6px" }}>
    <Stack sx={{ margin: "30px 15px 15px 25px" }}>
      <CircleImage iconName="icn-carrot-rx" backgroundColor={"black-10"} />
    </Stack>
    <FlexContainer direction="column">
      <H3 sx={{ paddingTop: "25px", paddingBottom: "10px" }}>
        <FormattedMessage defaultMessage="Carrot Rx required" />
      </H3>
      <Text sx={{ paddingBottom: "25px", paddingRight: "15px" }}>
        <FormattedMessage
          defaultMessage="To be eligible for reimbursement, medications must be filled through Carrot Rx. If these medications were filled
        through another pharmacy, please submit this expense to your health plan."
        />
      </Text>
    </FlexContainer>
  </FlexContainer>
)

export default CarrotRxMedicationCard
